module.exports = __webpack_public_path__ + "img/banner.b6f8e8c9.png";